module.exports = __webpack_public_path__ + "static/media/3.42c3a286.jpg";